import { ReportDetailsModel } from "./report-params.interface";

export interface TableColumn {
  columnDef: string;
  header: string;
  download?: (row: ReportDetailsModel) => void;
}

export enum ReportTableType {
  PENDING = 'pendingReportsTable',
  PICKUP = 'pickupReportsTable'
}

export interface TableRowEvent {
  operation: string;
  row: ReportDetailsModel
}
